<template>
    <DnsProviderForm
        :dns-provider="dnsProvider"
        :api-types="apiTypes"
        :stored-secrets="storedSecrets"
        :errors="errors"
        @form-submitted="eventUpdate"
    />
</template>

<script setup>
import DnsProviderForm from '~@/Components/Settings/DNSProvider/Form'
import { route } from '~@/Composables/route'

defineProps({
    dnsProvider: {
        type: Object,
        default () {
            return {}
        }
    },
    apiTypes: {
        type: Array,
        default: () => { return [] }
    },
    storedSecrets: {
        type: Object,
        default: () => ({})
    },
    errors: {
        type: Object,
        default () {
            return {}
        }
    }
})

const eventUpdate = (form) => {
    form.put(route('settings.dns-providers.update', {
        dns_provider: form.id
    }))
}
</script>

<style scoped lang="scss">

</style>
